import Socket from '@/utils/socket';
import { defineStore } from 'pinia';

interface SocketState {
  socket?: Socket;
}
export const useSocketStore = defineStore('socket', {
  state: (): SocketState => ({}),
});
